import React, { useState, useEffect } from 'react';
import ReactPlayer from 'react-player';

// https://github.com/cookpete/react-player/issues/1449#issuecomment-1117520592

function VideoPlayer({url}:{ url: string }) {
	const [isSSR, setIsSSR] = useState(true);

	useEffect(() => {
		setIsSSR(false);
	}, []);

	return (
		<div>
			{isSSR ? null : (
				<div className="aspect-video">
					<ReactPlayer
						controls
						url={url}
						width="100%"
						height="100%"
					/>
				</div>
			)}
		</div>
	);
}

export default VideoPlayer;
